import * as z from 'zod';
import { EntityId, Tag } from './base-schemas';
import { CountryModel } from './Country';
import { BookingModel } from './Booking';
import { isoDateTimeToDayJs } from './base-codecs';
export const CustomerModel = z.object({
    _tag: Tag('CustomerModel'),
    id: EntityId,
    given_name: z.string().nullable(),
    surname: z.string().nullable(),
    org_number: z.string().nullable(),
    org_name: z.string().nullable(),
    org_reference: z.string().nullable(),
    country_id: EntityId,
    dialling_code_country_id: EntityId.nullable(),
    phone_number: z.string().nullable(),
    email: z.string().nullable(),
    email_status: z.string().nullable(),
    street_name: z.string().nullable(),
    street_number: z.string().nullable(),
    zip: z.string().nullable(),
    city: z.string().nullable(),
    is_org: z.boolean(),
    class: z.string().optional(),
    created_at: isoDateTimeToDayJs.nullable(),
    updated_at: isoDateTimeToDayJs.nullable(),
    deleted_at: isoDateTimeToDayJs.nullable(),
    // Appended attributes
    full_name: z.string(),
    color: z.string(),
    initials: z.string(),
    short_address: z.string().optional(),
    // Relations (when loaded)
    get country() { return CountryModel.optional(); },
    get bookings() { return z.array(BookingModel).optional(); }
});
export const EnrichedCustomer = CustomerModel.extend({
    _tag: Tag('EnrichedCustomer'),
    isEnriched: z.literal(true),
    fullNameWithRef: z.string().optional(),
    shortAddress: z.string().optional(),
    fullPhoneNumber: z.string().optional(),
    // Relations
    get country() { return CountryModel.nullable().optional(); },
    get diallingCodeCountry() { return CountryModel.nullable().optional(); }
});
